import { Controller } from "@hotwired/stimulus"
import { canGoBack } from "../utils/history_back"

// Chevron de retour du fil d'Ariane sur téléphone (Shared::LayoutComponents::BreadcrumbComponent) :
// la page d'avant, comme le bouton des apps natives. Sans page d'avant dans la session, le lien
// suit son cours vers le niveau au-dessus.
export default class extends Controller {
  back(event) {
    if (!canGoBack()) return

    event.preventDefault()
    window.history.back()
  }
}
